import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  query GetShopPaymentGateways {\n    shop {\n      availablePaymentGateways {\n        id\n        name\n        config {\n          field\n          value\n        }\n      }\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  query GetShop {\n    shop {\n      displayGrossPrices\n      defaultCountry {\n        code\n        country\n      }\n      countries {\n        country\n        code\n      }\n      geolocalization {\n        country {\n          code\n          country\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var getShop = gql(_templateObject());
export var getShopPaymentGateways = gql(_templateObject2());